export const QueryParams = {
  LAST_TRACKING_STATUS: 'lastTrackingStatus',
  LAST_TRACKING_STATUS_EXCLUDE: 'lastTrackingStatusExclude',
  SHIPMENT_NUMBER: 'shipmentNumber',
  QUERY: 'query',
  COUNTRY: 'country',
  EMAIL: 'email',
  PHONE: 'phone',
  CUSTOMER: 'customer',
  ASSIGNMENT: 'assignment',
  CARRIER_HANDLE: 'carrierHandle',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  CHECKED_IN: 'checkedIn',
  SHOULD_USE_PROXY: 'shouldUseProxy',
  ORDER_BY: 'orderBy',
  ASCENDING: 'ascending',
  PACKAGES_DIVERTED_TO_SERVICE_POINT: 'packagesDivertedToServicePoint',
  WITH_SERVICE_POINT_COLLECTING_PROBLEM: 'withServicePointCollectingProblem',
  WITH_RECIPIENT_NOTIFICATION_PROBLEM: 'withRecipientNotificationProblem',
  EXCLUDE_FORWARDING_IGNORED: 'excludeForwardingIgnored',
  DISTRIBUTION_CHANNEL: 'distributionChannel',
  RETURN_ASSIGNMENTS: 'returnAssignments',
}
